import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { IconCheck } from '@travel-frontend/icons';
import { useTranslation } from 'next-i18next';
import { Badge } from '../../../../../components/HotelDetailsOverlay/components/AmadeusRatingSection/components/Badge.js';
import { RatingDropdown } from '../../../../../components/HotelDetailsOverlay/components/AmadeusRatingSection/components/Dropdown/index.js';
import { Flex, HeadlineMedium } from '../../../../../primitives/index.js';
export const ReviewsHeader = ({
  reviewsCount,
  onFilterChange,
  onSortChange,
  singleItem
}) => {
  const {
    t
  } = useTranslation('hotelDetailsOverlay');
  return _jsxs(Flex, {
    children: [_jsxs(Flex, {
      direction: "row",
      justifyContent: "space-between",
      alignItems: "center",
      children: [_jsx(HeadlineMedium, {
        children: t(reviewsCount === 0 ? 'amadeusRatingSection.noRatings' : 'amadeusRatingSection.xReviews', {
          count: reviewsCount
        })
      }), _jsx(Badge, {
        icon: _jsx(IconCheck, {
          fontScale: "16px"
        }),
        children: t('amadeusRatingSection.verified')
      })]
    }), _jsxs(Flex, {
      direction: "row",
      children: [_jsx(RatingDropdown, {
        onDropdownChange: value => {
          onFilterChange(value === 'all' ? undefined : value);
        },
        method: "filters"
      }), _jsx(RatingDropdown, {
        onDropdownChange: value => {
          onSortChange(value);
        },
        singleItem: singleItem,
        method: "sorting"
      })]
    })]
  });
};